<div *ngIf="visible" class="restore-card-button-container">
  <a type="button" (click)="onClick()">
    <div class="image-container" [inlineSVG]='"/static/images/svg/card_warning.svg"'>
    </div>
  </a>
</div>
